<template>
    <div class="px-3 pb-0 pb-lg-5 px-lg-0 position-relative">
        <div @click="toggleFilter(true)" class="d-flex d-lg-none sparepartsproductfabricselection__filter__filter-icon position-absolute">
            <svg xmlns="http://www.w3.org/2000/svg" width="16.162" height="14.897" viewBox="0 0 16.162 14.897">
                <path id="filter" d="M16.114,9.964a.49.49,0,0,0-.443-.281H.489a.49.49,0,0,0-.378.8l5.836,7.079V24.09a.49.49,0,0,0,.707.439L9.934,22.9a.49.49,0,0,0,.272-.438l.006-4.9,5.836-7.079A.49.49,0,0,0,16.114,9.964ZM9.345,17.075a.49.49,0,0,0-.112.311l-.006,4.774-2.3,1.14V17.387a.49.49,0,0,0-.112-.312L1.528,10.663h13.1Z" transform="translate(0 -9.683)" :fill="svgcolor2"/>
            </svg>
        </div>
        <div v-if="filtersLoaded.length > 1" :class="[ filterIsOpen ? 'open' : '', loaded ? 'sparepartsproductfabricselection__filter__loaded' : '', 'sparepartsproductfabricselection__filter--'+theme, 'bg-'+theme]" class="position-fixed position-lg-static w-100 w-lg-auto top-0 sparepartsproductfabricselection__filter d-flex flex-wrap">
            <div class="backToSection position-relative w-100 d-flex px-1 py-3 d-lg-none justify-content-between justify-content-lg-start align-items-center" :class="'backToSection--'+theme">
                <template v-if="theme == 'white'">
                    <svg class="position-absolute" xmlns="http://www.w3.org/2000/svg" width="6.774" height="5" viewBox="0 0 6.774 5"><path id="play-button" d="M4.93,3.254.253.028A.161.161,0,0,0,0,.161V6.613a.161.161,0,0,0,.253.133L4.93,3.52a.161.161,0,0,0,0-.265Z" transform="translate(6.774) rotate(90)" fill="#000" opacity="0.8"></path></svg>
                    <svg @click="toggleFilter(false)" class="d-none cross position-absolute" height="12" viewBox="0 0 512 512" width="12" xmlns="http://www.w3.org/2000/svg">
                        <g id="_02_User" data-name="02 User">
                            <path fill="#000" d="m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z"/>
                            <path fill="#000" d="m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z"/>
                        </g>
                    </svg>
                </template>
                <template v-else>
                    <svg class="position-absolute" xmlns="http://www.w3.org/2000/svg" width="6.774" height="5" viewBox="0 0 6.774 5"><path id="play-button" d="M4.93,3.254.253.028A.161.161,0,0,0,0,.161V6.613a.161.161,0,0,0,.253.133L4.93,3.52a.161.161,0,0,0,0-.265Z" transform="translate(6.774) rotate(90)" fill="#fff" opacity="0.8"></path></svg>
                    <svg @click="toggleFilter(false)" class="d-none cross position-absolute" height="12" viewBox="0 0 512 512" width="12" xmlns="http://www.w3.org/2000/svg">
                        <g id="_02_User" data-name="02 User">
                            <path fill="#fff" d="m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z"/>
                            <path fill="#fff" d="m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z"/>
                        </g>
                    </svg>
                </template>
                <p @click="toggleFilter(false)" :class="'text-primary-'+theme" class="py-3 pl-5">{{ t('pagination.previous') }}</p>
                <p :class="'text-primary-'+theme" class="py-3 px-5 text-right" @click="setFilter('all','none')">{{t('general.setbackall')}}</p>
            </div>
            <div class="d-flex flex-column flex-lg-row flex-wrap w-100 w-lg-auto vh-100 h-lg-auto px-4 p-lg-0">
                <div v-for="(filter, index) in filtersLoaded" :key="filter.filterId" class="sparepartsproductfabricselection__filter__item position-static position-lg-relative mr-0 mr-lg-3" :class="'bg-third-fourth-hover--'+theme">
                    <div @click="underMenuOpen = index" class="sparepartsproductfabricselection__filter__item__selected d-flex justify-content-between align-items-center">
                        <template v-if="filter.selected == 'none'">
                            <p>{{filter.label}}</p>
                        </template>
                        <template v-else>
                            <p v-if="filter.children[filter.selected].hasOwnProperty('title')" class="d-none d-lg-flex align-items-center">
                                <template v-if="filter.children[filter.selected].hasOwnProperty('hex')">
                                    <span class="hexcircle mr-3" v-if="filter.children[filter.selected].hex != null && filter.children[filter.selected].hex != ''" :style="{ backgroundColor: filter.children[filter.selected].hex }"></span>
                                </template>
                                {{filter.children[filter.selected].title}}
                            </p>
                            <p v-else class="d-none d-lg-flex">{{filter.children[filter.selected]}}</p>
                            <p class="d-flex d-lg-none">{{filter.label}}</p>
                        </template>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6.774" height="5" viewBox="0 0 6.774 5">
                            <path id="play-button" d="M4.93,3.254.253.028A.161.161,0,0,0,0,.161V6.613a.161.161,0,0,0,.253.133L4.93,3.52a.161.161,0,0,0,0-.265Z" transform="translate(6.774) rotate(90)" :fill="svgcolor1" opacity="0.8"/>
                        </svg>
                    </div>
                    <div :class="[ underMenuOpen == index ? 'open' : '', 'bg-'+theme]" class="underMenu position-absolute w-100 vh-100 h-lg-auto">
                        <div class="backToSection position-relative w-100 d-flex px-1 py-3 d-lg-none justify-content-between align-items-center" :class="'backToSection--'+theme">
                            <template v-if="theme == 'white'">
                                <svg class="position-absolute" xmlns="http://www.w3.org/2000/svg" width="6.774" height="5" viewBox="0 0 6.774 5"><path id="play-button" d="M4.93,3.254.253.028A.161.161,0,0,0,0,.161V6.613a.161.161,0,0,0,.253.133L4.93,3.52a.161.161,0,0,0,0-.265Z" transform="translate(6.774) rotate(90)" fill="#000" opacity="0.8"></path></svg>
                                <svg class="d-none cross position-absolute" height="12" viewBox="0 0 512 512" width="12" xmlns="http://www.w3.org/2000/svg">
                                    <g id="_02_User" data-name="02 User">
                                        <path fill="#000" d="m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z"/>
                                        <path fill="#000" d="m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z"/>
                                    </g>
                                </svg>
                            </template>
                            <template v-else>
                                <svg class="position-absolute" xmlns="http://www.w3.org/2000/svg" width="6.774" height="5" viewBox="0 0 6.774 5"><path id="play-button" d="M4.93,3.254.253.028A.161.161,0,0,0,0,.161V6.613a.161.161,0,0,0,.253.133L4.93,3.52a.161.161,0,0,0,0-.265Z" transform="translate(6.774) rotate(90)" fill="#fff" opacity="0.8"></path></svg>
                                <svg class="d-none cross position-absolute" height="12" viewBox="0 0 512 512" width="12" xmlns="http://www.w3.org/2000/svg">
                                    <g id="_02_User" data-name="02 User">
                                        <path fill="#fff" d="m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z"/>
                                        <path fill="#fff" d="m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z"/>
                                    </g>
                                </svg>
                            </template>
                            <p :class="'text-primary-'+theme" class="py-3 pl-5" @click="underMenuOpen = 'undefined'" >{{ t('pagination.previous') }}</p>
                            <p :class="'text-primary-'+theme" class="py-3 px-5 text-right" @click="setFilter(index,'none')">{{t('general.setback')}}</p>

                        </div>
                        <ul class="w-100 px-4 px-lg-0 pt-lg-3 mb-0 h-100 h-lg-auto">
                            <li class="d-flex align-items-center justify-content-between" :class="'bg-third-fourth-hover--'+theme" v-for="(filterchild, index2) in filter.children" :key="index2" @click="setFilter(index,index2)">
                                <p class="d-flex align-items-center" v-if="filterchild.hasOwnProperty('title')" :class="[ filter.selected == index2 ? 'selected' : '']">
                                    <template v-if="filterchild.hasOwnProperty('hex')">
                                        <span class="hexcircle mr-3" v-if="filterchild.hex != null && filterchild.hex != ''" :style="{ backgroundColor: filterchild.hex }"></span>
                                    </template>
                                    {{filterchild.title}}
                                </p>
                                <p v-else :class="[ filter.selected == index2 ? 'selected' : '']">{{filterchild}}</p>
                                <svg v-if="filter.selected == index2" class="d-flex d-lg-none" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                     width="12px" height="12px" viewBox="0 0 78.369 78.369" style="enable-background:new 0 0 78.369 78.369;"
                                     xml:space="preserve">
                                    <g>
                                        <path :fill="svgcolor2" d="M78.049,19.015L29.458,67.606c-0.428,0.428-1.121,0.428-1.548,0L0.32,40.015c-0.427-0.426-0.427-1.119,0-1.547l6.704-6.704
                                            c0.428-0.427,1.121-0.427,1.548,0l20.113,20.112l41.113-41.113c0.429-0.427,1.12-0.427,1.548,0l6.703,6.704
                                            C78.477,17.894,78.477,18.586,78.049,19.015z"/>
                                    </g>
                                </svg>
                            </li>
                            <li class="setback w-100 d-none d-lg-block position-absolute bottom-0 left-0 position-lg-static justify-content-center d-sm-none" :class="'bg-third-fourth-hover--'+theme" @click="setFilter(index,'none')">
                                {{t('general.setback')}}
                            </li>
                            <li class="w-100 d-flex d-lg-block position-absolute bottom-0 left-0 position-lg-static justify-content-center d-md-none d-lg-none d-xl-none">
                                <div v-if="noFilterActive == false" class="showproduct-button py-3 px-5 mx-3 d-flex mt-0 mb-2 d-md-none into_basket  into_basket--mobile justify-content-center" :class="'bg-hover--'+theme" @click="toggleFilter(false)">
                                    <span>{{t('general.use')}}</span>&nbsp;<p v-if="amount > 0"> ({{amount }} {{t('general.results')}})</p>
                                </div>
                                <div v-else class="showproduct-button showproduct-button--else py-3 px-5 mx-3 d-flex mt-0 mb-2 d-md-none into_basket  into_basket--mobile justify-content-center" :class="'bg-hover--'+theme" @click="toggleFilter(false)">
                                    <p>{{t('modal.close')}}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="left-0 position-absolute px-3 w-100 showproduct-button__outer">
                    <div v-if="noFilterActive == false" class="showproduct-button py-3 px-5 d-flex mt-0 mb-4 d-md-none into_basket  into_basket--mobile justify-content-center" :class="'bg-hover--'+theme" @click="toggleFilter(false)">
                        <span>{{t('general.use')}}</span>&nbsp;<p v-if="amount > 0"> ({{amount }} {{t('general.results')}})</p>
                    </div>
                    <div v-else class="showproduct-button showproduct-button--else py-3 px-5 d-flex mt-0 mb-4 d-md-none into_basket  into_basket--mobile justify-content-center" :class="'bg-hover--'+theme" @click="toggleFilter(false)">
                        <p>{{t('modal.close')}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {FireI18n} from 'fire-js-i18n';

export default {
    name: 'filters',
    data: () => ({
        loaded: true,
        svgcolor1: '',
        svgcolor2: '',
        filtersLoaded: [],
        filterIsOpen: false,
        underMenuOpen: 'undefined',
        noFilterActive: true
    }),
    computed: {

    },
    components: {

    },
    directives: {

    },
    mixins: [

    ],
    props: {
        amount: Number,
        filters: Array,
        theme: String
    },
    watch: {

    },
    created() {

    },
    destroyed() {

    },
    mounted () {
        let self = this;
        this.setColors(this.theme);
        this.filtersLoaded = this.filters;
        this.filtersLoaded.forEach(function(item,key) {
            if(item['children'].length == 0){
                self.filtersLoaded.splice(key, 1);
            }
        });
    },
    methods: {
        t(key, options)
        {
            return FireI18n.t(key, options);
        },
        toggleFilter(value){
            this.filterIsOpen = value;
            if(value == false){
                document.body.classList.remove("overflow-hidden");
            }else{
                document.body.classList.add("overflow-hidden");
            }
        },
        setColors(theme) {
            if(theme == 'dark'){
                this.svgcolor1 = '#fff';
                this.svgcolor2 = '#fdc300';
            }else if(theme == 'white'){
                this.svgcolor1 = '#000';
                this.svgcolor2 = '#c80000';
            }
        },
        setFilter(index, index2) {
            let self = this;
            if(index == 'all'){
                this.filtersLoaded.forEach(function(item) {
                    item['selected'] = index2;
                });
            }else{
                this.filtersLoaded[index]['selected'] = index2;
            }
            self.noFilterActive = true;
            this.filtersLoaded.forEach(function(item) {
                if(item['selected'] != 'none'){
                    self.noFilterActive = false;
                }
            });
            this.$emit('applyFilters', this.filtersLoaded);
        },
    }
};
</script>

<style lang="scss">
@import "frontend/styles/framework";

.sparepartsproductfabricselection__filter{
    p{
        span{
            &.hexcircle{
                width: 14px;
                height: 14px;
                border-radius: 50%;
            }
        }
    }
    .showproduct-button {
        cursor: pointer;
        width: 100%;
        font-size: 0.85rem;
        &__outer{
            bottom: 82px;
        }
        p{
            font-weight: 200;
        }
        span{
            font-weight: 600;
        }
        &.bg-hover{
            &--dark{
                transition: all 0.3s;
                background-color: $black;
                color: $secondary-dark;
                border: solid 1px $secondary-dark;
                &:hover{
                    color: $black;
                    background-color: $secondary-dark;
                }
            }
            &--white{
                transition: all 0.3s;
                background-color: $white;
                color: $dark;
                border: solid 1px $secondary-white;
                &:hover{
                    color: $secondary-white;
                    background-color: $white;
                }
            }
        }
        &--else{
            &.bg-hover{
                &--dark{
                    transition: all 0.3s;
                    background-color: $black;
                    color: $white;
                    border: solid 1px $white;
                    &:hover{
                        color: $black;
                        background-color: $white;
                    }
                }
                &--white{
                    transition: all 0.3s;
                    background-color: $white;
                    color: $dark;
                    border: solid 1px $black;
                    &:hover{
                        color: $white;
                        background-color: $black;
                    }
                }
            }
        }
    }
    &__filter-icon{
        cursor: pointer;
        right: 22px;
        top: -32px;
    }
    z-index: 10000;
    transition: all 0.3s;
    opacity: 0;
    visibility: hidden;
    left: 103%;
    .backToSection{
        &--white{
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        }
        &--dark{
            border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        }
    }
    &__loaded{
        opacity: 0;
        visibility: hidden;
        &.open{
            left: 0%;
            opacity: 1;
            visibility: visible
        }
    }
    &--dark{
        ul{
            li{
                &.setback {
                    color: $secondary-dark;
                }
            }
        }
    }
    &--white{
        ul{
            li{
                &.setback{
                    font-weight: 700;
                    color: $secondary-white;
                }
            }
        }
    }
    &__item{
        &.bg-third-fourth-hover{
            &--dark{
                background-color: $black;
                &:hover{
                    .sparepartsproductfabricselection__filter__item__selected{
                        svg{
                            margin-right: -5px;
                        }
                    }
                }
                border-top: 1px solid rgba(255, 255, 255, 0.2);
                &:first-child{
                    border-top: none;
                }
            }
            &--white{
                background-color: $white;
                &:hover{
                    .sparepartsproductfabricselection__filter__item__selected{
                        background-color: $white;
                        svg{
                            margin-right: -5px;
                        }
                    }
                }
                border-top: 1px solid rgba(0, 0, 0, 0.2);
                &:first-child{
                    border-top: none;
                }
            }
        }
        &__selected{
            cursor: pointer;
            min-width: 205px;
            min-height: 50px;
            padding: 18px 0px;
            font-size: 0.8rem;
            font-weight: 200;
            transition: background-color 0.3s;
            svg{
                transition: all 0.3s;
                transform: rotate(270deg);
            }
        }
        .underMenu{
            z-index: 2;
            transition: all 0.3s;
            visibility: visible;
            opacity: 1;
            top: 0%;
            left: 110%;
            &.open{
                left: 0%;
            }
        }
        ul{
            display: flex;
            flex-direction: column;
            overflow-y: scroll;
            -ms-overflow-style: none; /* for Internet Explorer, Edge */
            scrollbar-width: none; /* for Firefox */
            overflow-y: scroll;
            &::-webkit-scrollbar {
                display: none; /* for Chrome, Safari, and Opera */
            }
            li{
                padding: 17px 0px;
                list-style: none;
                cursor: pointer;
                font-size: 0.8rem;
                font-weight: 200;
                transition: background-color 0.3s;
                // border-bottom: 1px solid $black;
                &.bg-third-fourth-hover{
                    &--dark{
                        .selected{
                            color: $secondary-dark;
                        }
                        background-color: $black;
                        &:hover{
                            color: $secondary-dark;
                        }
                        border-top: 1px solid rgba(255, 255, 255, 0.2);
                        &:first-child{
                            border-top: none;
                        }
                    }
                    &--white{
                        .selected{
                            color: $secondary-white;
                        }
                        background-color: $white;
                        &:hover{
                            background-color: $white;
                        }
                        border-top: 1px solid rgba(0, 0, 0, 0.2);
                        &:first-child{
                            border-top: none;
                        }
                    }
                }
                &.setback{
                    //bottom: 50px;
                }
                &:last-child{
                    padding-bottom: 10px;
                }
            }
        }
        &:hover{
            .underMenu{
                visibility: visible;
                opacity: 1;
            }
        }
    }
    @media (min-width: 992px) {
        &__loaded {
            opacity: 1;
            visibility: visible;
        }
        &__item {
            &.bg-third-fourth-hover{
                &--dark{
                    background-color: $third_dark;
                    .selected{
                        color: $white;
                    }
                    &:hover{
                        .sparepartsproductfabricselection__filter__item__selected{
                            background-color: $fourth_dark;
                            svg{
                                margin-right: 0px;
                            }
                        }
                    }
                    border-top: none;
                }
                &--white{
                    background-color: $specialbackground-white;
                    .selected{
                        color: $secondary-white;
                    }
                    &:hover{
                        .sparepartsproductfabricselection__filter__item__selected{
                            background-color: $fourth_white;
                            svg{
                                margin-right: 0px;
                            }
                        }
                    }
                    border-top: none;
                }
            }
            &__selected {
                padding: 18px 25px;
                svg {
                    transform: rotate(0deg);
                }
            }
            .underMenu{
                left: 0%;
                top: 100%;
                visibility: hidden;
                opacity: 0;
            }
            ul{
                li{
                    padding: 7px 25px;
                    &.bg-third-fourth-hover{
                        &--dark{
                            border-top: none;
                            background-color: $third_dark;
                            &:hover{
                                color: $white;
                                background-color: $fourth_dark;
                            }
                        }
                        &--white{
                            background-color: $specialbackground-white;
                            &:hover{
                                background-color: $fourth_white;
                            }
                            border-top: none;
                        }
                    }
                    &:last-child{
                        padding-bottom: 10px;
                    }
                }
            }
        }
    }
}

</style>